import { useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft, MapPin } from 'lucide-react';
import { useLang } from '../i18n';
import { useSEO } from '../seo';
import { Reveal } from '../components/Reveal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TravelGuideArticlePage() {
  const { slug } = useParams();
  const { t } = useLang();
  const [guide, setGuide] = useState(null);
  const [missing, setMissing] = useState(false);

  useSEO(
    guide ? `${guide.title} | Eco Collection` : 'Guia | Eco Collection',
    guide ? guide.excerpt : 'Guia de viagem Eco Collection'
  );

  useEffect(() => {
    fetch(`${API}/guides/${slug}`)
      .then((r) => {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(setGuide)
      .catch(() => setMissing(true));
  }, [slug]);

  if (missing) return <Navigate to="/travel-guides" replace />;
  if (!guide) return <div className="min-h-screen bg-eco-deep" data-testid="guide-loading" />;

  return (
    <div data-testid={`guide-article-${slug}`}>
      <section className="relative overflow-hidden bg-eco-deep pt-32 pb-14 md:pt-40">
        {guide.image && (
          <>
            <img src={guide.image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
            <div className="absolute inset-0 bg-gradient-to-b from-eco-deep/50 to-eco-deep" />
          </>
        )}
        <div className="relative mx-auto max-w-3xl px-5 md:px-8">
          <Link to="/travel-guides" data-testid="guide-back-link" className="inline-flex items-center gap-1.5 text-sm text-white/60 transition-colors hover:text-eco-gold">
            <ArrowLeft size={15} /> {t('back')}
          </Link>
          <Reveal className="mt-6">
            <p className="flex items-center gap-1.5 text-xs font-semibold tracking-[0.18em] uppercase text-eco-gold">
              <MapPin size={12} /> {guide.destination}
            </p>
            <h1 className="eco-page-title mt-3 text-white">{guide.title}</h1>
            {guide.excerpt && <p className="mt-4 max-w-2xl text-base leading-[1.65] font-normal text-white/65">{guide.excerpt}</p>}
          </Reveal>
        </div>
      </section>
      <section className="bg-white py-14 md:py-20">
        <Reveal className="eco-reading px-5 md:px-8">
          {guide.content.split('\n\n').map((p, i) => (
            <p key={i} className="eco-body mb-6 text-eco-ink/75">{p}</p>
          ))}
        </Reveal>
      </section>
    </div>
  );
}
